import { render } from "./Notifications.vue?vue&type=template&id=68d64f4a&scoped=true"
import script from "./Notifications.vue?vue&type=script&lang=js"
export * from "./Notifications.vue?vue&type=script&lang=js"

import "./Notifications.vue?vue&type=style&index=0&id=68d64f4a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-68d64f4a"

export default script